import React from 'react';
import type { FC } from 'react';
import { match } from 'variant';
import { Alert, Spinner, useAsync } from '@wix/cli-ui-kit';
import { updateEnvFile } from '@wix/cli-fs';
import { useBackendAsAServiceClient } from '@wix/backend-as-a-service-client';
import { ENV_FILE_NAME, getEnvFilePath } from '@wix/cli-astro-definitions';
import { useProjectModel } from '../../model.js';

const ENV_NAME = 'prod';

export const EnvPull: FC = () => {
  const { model } = useProjectModel();
  const backendAsAServiceClient = useBackendAsAServiceClient();

  const { status } = useAsync(async () => {
    const variables = await backendAsAServiceClient.getAppEnvironmentVariables(
      model.config.appId,
      ENV_NAME
    );

    await updateEnvFile(getEnvFilePath(model.projectFolder), variables);
  }, []);

  return match(status, {
    Loading: () => (
      <Spinner text={`Pulling environment "${ENV_NAME}" variables...`} />
    ),
    Success: () => (
      <Alert type="success">
        Environment variables written to "{ENV_FILE_NAME}"
      </Alert>
    ),
    Error: () => null,
    NotRequested: () => null,
  });
};
